import React, { useContext, useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { baseURL } from "../services/api";
import axios from "axios";
import OrgContext from "../organisation/OrgContext";

import {
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import AuthContext from "../components/shared/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import { format, parseISO } from "date-fns";

const Tickets = () => {
  const { organisation } = useContext(OrgContext);
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const getTickets = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/data/tickets/${organisation?.id}`,
      );

      const formattedTickets = response.data.data.map((ticket) => {
        // Vérifiez que created_at existe et est une chaîne valide
        const createdAt = ticket.created_at;
        const updatedAt = ticket.updated_at;
        let formattedDateC = "";
        let formattedDateU = "";
        if (createdAt) {
          try {
            const dateObjectC = parseISO(createdAt);
            const dateObjectU = parseISO(updatedAt);
            formattedDateC = format(dateObjectC, "dd MMMM yyyy, HH:mm");
            formattedDateU = format(dateObjectU, "dd MMMM yyyy, HH:mm");
          } catch (error) {
            console.error("Erreur lors du formatage de la date :", error);
            formattedDateU = "Date invalide"; // Valeur par défaut en cas d'erreur
            formattedDateU = "Date invalide";
          }
        } else {
          formattedDateU = "Date non disponible"; // Valeur par défaut si created_at est null ou indéfini
          formattedDateC = "Date non disponible";
        }

        return {
          id: ticket.id,
          title: ticket.title,
          type: ticket.type,
          etatId: ticket.etat_id,
          content: ticket.contenu,
          createdAt: formattedDateC, // Utiliser la date formatée
          updatedAt: formattedDateU,
          status: ticket.etat.title,
          userName: ticket.user.name,
        };
      });

      setTickets(formattedTickets);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setError("Une erreur est survenue lors de la récupération des tickets.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (organisation?.id) {
      getTickets();
    }
  }, [organisation]);
  const columns = [
    { field: "id", headerName: t("id"), width: 50 },
    { field: "title", headerName: t("title"), width: 150 },
    { field: "type", headerName: t("type"), width: 150 },
    { field: "createdAt", headerName: t("createdAt"), width: 180 },
    { field: "updatedAt", headerName: t("updatedAt"), width: 180 },
    { field: "status", headerName: t("status"), width: 130 },
    { field: "userName", headerName: t("userName"), width: 150 },
    {
      field: "action",
      headerName: t("action"),
      width: 250,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const onEdit = () => {
          const ticket = params.row;
          if (ticket.etatId === 2) {
            toast.error(
              "Désolé, mais vous ne pouvez pas modifier un ticket qui est en cours de préparation.",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              },
            );
          } else {
            setSelectedTicket(params.row);
            setIsEditing(true);
            setIsAdding(false);
            setOpenModal(true);
          }
        };

        const onDetails = () => {
          setSelectedTicket(params.row);
          setIsEditing(false);
          setIsAdding(false);
          setOpenModal(true);
        };
        const onDelete = (e) => {
          const ticket = params.row;

          if (ticket.etatId === 2) {
            toast.error(
              "Désolé, mais vous ne pouvez pas supprimer un ticket qui est en cours de préparation.",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              },
            );
          } else {
            deleteTicket(ticket.id);
          }
        };

        // Function to delete the ticket
        const deleteTicket = async (ticketId) => {
          try {
            await axios.delete(`${baseURL}/data/tickets/${ticketId}`);
            toast.success("Ticket a été supprimé avec succès", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            // Refresh the tickets list or update state to remove the deleted ticket
            getTickets();
          } catch (error) {
            console.error("Erreur lors de la suppression du ticket:", error);
            toast.error(
              "Une erreur est survenue lors de la suppression du ticket",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              },
            );
          }
        };

        return (
          <div className="btn-list">
            <button onClick={onEdit} className="btn btn-sm btn-primary">
              <span className="fe fe-edit"></span>
            </button>
            <button onClick={onDetails} className="btn btn-sm btn-secondary">
              <span className="fe fe-eye"></span>
            </button>
            <button
              // disabled={params.row.etatId === 2}
              onClick={onDelete}
              className="btn btn-sm btn-danger"
            >
              <span className="fe fe-trash-2"></span>
            </button>
          </div>
        );
      },
    },
  ];

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedTicket(null);
    setIsEditing(false);
    setIsAdding(false);
  };

  const handleSaveChanges = async () => {
    try {
      if (isEditing) {
        // Logic to update an existing ticket
        await axios.patch(`${baseURL}/data/tickets/${selectedTicket.id}`, {
          ...selectedTicket,
          organisation_id: organisation.id,
          userId: user.id,
        });
        console.log({
          ...selectedTicket,
          organisation_id: organisation.id,
          userId: user.id,
        });
      } else if (isAdding) {
        // Logic to add a new ticket
        const response = await axios.post(`${baseURL}/data/tickets`, {
          ...selectedTicket,
          organisation_id: organisation.id,
        });
      }
      getTickets();
      handleCloseModal();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde du ticket :", error);
    }
  };

  const handleAddTicket = () => {
    setSelectedTicket({
      id: null,
      title: "",
      type: "",
      content: "",
      createdAt: new Date().toISOString(),
      status: "Nouveau",
      userId: user.id,
      etatId: 1,
      userName: "Utilisateur",
    });
    setIsAdding(true);
    setOpenModal(true);
  };

  return (
    <div>
      <div style={{ width: "80%", margin: 10 }}>
        <h1 className="page-title breadcumpsHeader">{t("pageTitle")}</h1>
        <p style={{ marginTop: 5 }}>{t("helpText")}</p>
      </div>


      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header container-fluid row">
              <div className="col-md-9 col-sm-12 card-title">
                {t("ticketListTitle")}
              </div>

              <div className="card-title col-md-3 d-flex justify-content-end">
                <button className="btn btn-primary" onClick={handleAddTicket}>
                  {t("addTicketButton")}
                </button>
              </div>
            </div>

            <div className="card-body">
              {loading ? (
                <p>{t("loadingTickets")}</p>
              ) : error ? (
                <p>{t("errorLoadingTickets")}</p>
              ) : (
                <div className="table-responsive">
                <div style={{ height: 400, width: "100%" }}>
                  <DataGrid
                    rows={tickets}
                    columns={columns}
                    pageSize={5}
                    pagination={false}
                    slots={{
                      toolbar: GridToolbar,
                      loadingOverlay: LinearProgress,
                    }}
                    componentsProps={{
                      toolbar: {
                        csvOptions: { disableToolbarButton: true },
                        printOptions: { disableToolbarButton: true },
                      },
                    }}
                  />
                </div>
               </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal pour modifier/afficher les détails du ticket */}
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>
          {isEditing
            ? t("editTicket")
            : isAdding
              ? t("addTicket")
              : t("ticketDetails")}
        </DialogTitle>
        <DialogContent>
          {selectedTicket && (
            <>
              <TextField
                margin="dense"
                label={t("titleLabel")}
                type="text"
                fullWidth
                value={selectedTicket.title}
                onChange={(e) =>
                  setSelectedTicket({
                    ...selectedTicket,
                    title: e.target.value,
                  })
                }
                disabled={!isEditing && !isAdding}
              />
              <FormControl component="fieldset" margin="dense">
                <FormLabel component="legend">{t("typeLabel")}</FormLabel>
                <RadioGroup
                  row
                  aria-label="type"
                  name="type"
                  value={selectedTicket.type}
                  onChange={(e) =>
                    setSelectedTicket({
                      ...selectedTicket,
                      type: e.target.value,
                    })
                  }
                >
                  <FormControlLabel
                    value="Techniques"
                    control={<Radio />}
                    label="Techniques"
                    disabled={!isEditing && !isAdding}
                  />
                  <FormControlLabel
                    value="Support"
                    control={<Radio />}
                    label="Support"
                    disabled={!isEditing && !isAdding}
                  />
                </RadioGroup>
              </FormControl>
              <TextField
                margin="dense"
                label={t("contentLabel")}
                type="text"
                fullWidth
                multiline
                rows={4}
                value={selectedTicket.content}
                onChange={(e) =>
                  setSelectedTicket({
                    ...selectedTicket,
                    content: e.target.value,
                  })
                }
                disabled={!isEditing && !isAdding}
              />
            </>
          )}
        </DialogContent>
        {(isEditing || isAdding) && (
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
              {t("cancelButton")}
            </Button>
            <Button onClick={handleSaveChanges} color="primary">
              {t("saveButton")}
            </Button>
          </DialogActions>
        )}
      </Dialog>
      <ToastContainer />
    </div>
  );
};

export default Tickets;
